import { render, staticRenderFns } from "./issueImmPass.vue?vue&type=template&id=4159c3c0&"
import script from "./issueImmPass.vue?vue&type=script&lang=js&"
export * from "./issueImmPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports